import { render, staticRenderFns } from "./VueDatepickerLocalCalendar.vue?vue&type=template&id=667a3f64"
import script from "./VueDatepickerLocalCalendar.vue?vue&type=script&lang=js"
export * from "./VueDatepickerLocalCalendar.vue?vue&type=script&lang=js"
import style0 from "./VueDatepickerLocalCalendar.vue?vue&type=style&index=0&id=667a3f64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports